// extracted by mini-css-extract-plugin
export default {"filterBadgeWrapper":"styles_filterBadgeWrapper__f94j2","removeButton":"styles_removeButton__iiYqq","label":"styles_label__RUU+o","value":"styles_value__Iwl35"};